<template>
    <div :id="data.mapId" :ref="e => (refs.map = e)"></div>
</template>

<script>
import L from "leaflet";
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png";
import iconUrl from "leaflet/dist/images/marker-icon.png";
import shadowUrl from "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/leaflet.css";
import { defineComponent, onMounted, reactive } from "vue";
import { randomUuid } from "../../utils/util";

export default defineComponent({
    components: {},
    props: {
        menuContext: {}
    },
    emits: ["ready"],
    setup(props, { emit }) {
        const data = reactive({ mapId: randomUuid() });
        const refs = reactive({ map: null });
        onMounted(() => {
            data.map = L.map(data.mapId, { scrollWheelZoom: false }).setView([10, 102], 4);
            L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(data.map);
            L.Marker.prototype.options.icon = L.icon({
                iconRetinaUrl,
                iconUrl,
                shadowUrl,
                iconSize: [25, 41],
                iconAnchor: [12, 41],
                popupAnchor: [1, -34],
                tooltipAnchor: [16, -28],
                shadowSize: [41, 41]
            });
            refs.map.addEventListener("mousewheel", event => {
                event.stopPropagation();
                if (event.ctrlKey === true) {
                    event.preventDefault();
                    data.map.scrollWheelZoom.enable();
                    refs.map.classList.remove("map-scroll");
                    setTimeout(() => data.map.scrollWheelZoom.disable(), 1000);
                } else {
                    data.map.scrollWheelZoom.disable();
                    refs.map.classList.add("map-scroll");
                }
            });
            emit("ready", { map: data.map });
        });
        return { props, data, refs };
    }
});
</script>

<style>
.map-scroll:before {
    content: "Use ctrl + scroll to zoom the map";
    position: absolute;
    top: 0;
    right: 10px;
    z-index: 1000;
    font-size: 24px;
}
.map-scroll:after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    content: "";
    background: #00000061;
    z-index: 1000;
}
</style>
